import { Universe } from '../../core/universes';
import * as enums from '../../enums';
import { IrrigationType, SoilTexture } from '../plots';
import mockedPaginatedResponse from './mockedPaginatedResponse';
import mockedRequester from './mockedRequester';
export const mockedPlot = {
    kind: 'plot',
    createdAt: '1623840436',
    /* Do not mock a capacitive equation here to keep it consistent with reality */
    meta: {
        irrigationType: IrrigationType.sprinkle,
        thresholdsProfileId: 1,
        grapeVisionId: 'myGrapeVisionId'
    },
    activeOptions: [enums.OptionCode.avizio, enums.OptionCode.cumulativeSum],
    archived: false,
    availableAlertTypes: [],
    availableMeasures: ['HPOT'],
    currentMeasurementConfigs: [
        {
            deviceId: 1,
            horizon: {
                id: 1,
                label: 'depth',
                value: 20
            },
            id: 1,
            label: 'label',
            metric: 'HPOT',
            plotId: 1,
            startDate: ''
        }
    ],
    deviceIds: [0, 1, 2],
    hasVirtualDevice: true,
    id: 1,
    isFavorite: true,
    myRole: enums.OrgRole.admin,
    name: 'plot',
    organizationId: 1,
    organizationName: 'Mocked Plot Organization Name',
    shape: {
        bbox: [-5.4534286, 41.2632185, 9.8678344, 51.268318], // france bounding box
        coordinates: [0, 0, 0, 0],
        type: 'Point'
    },
    soilTexture: SoilTexture.clay,
    soilTextureComposition: null,
    timezone: 'Europe/Paris',
    location: { type: 'Point', coordinates: [-1.553621, 47.218371] },
    reverseGeocoding: 'Sautron, Loire-Atlantique',
    availableUniverses: [Universe.weather, Universe.irrigation]
};
const mockedSoilMeshResponse = { soilTexture: SoilTexture.clay };
export const mockedPlotPaginatedResponse = mockedPaginatedResponse([mockedPlot]);
const mock = {
    delete: mockedRequester(undefined, 'plots.delete'),
    create: mockedRequester(mockedPlot, 'plots.create'),
    createFromStation: mockedRequester(mockedPlot, 'plots.createFromStation'),
    archive: mockedRequester(mockedPlot, 'plots.archive'),
    get: mockedRequester(mockedPlot, 'plots.get'),
    getMany: mockedRequester(mockedPlotPaginatedResponse, 'plots.getMany'),
    getPage: mockedRequester(mockedPlotPaginatedResponse, 'plots.getPage'),
    setFavorite: mockedRequester(mockedPlot, 'plots.setFavorite'),
    unsetFavorite: mockedRequester(mockedPlot, 'plots.unsetFavorite'),
    updateDevices: mockedRequester(mockedPlot, 'plots.updateDevices'),
    update: mockedRequester(mockedPlot, 'plots.update'),
    getAllPages: mockedRequester([mockedPlot], 'plots.getAllPages'),
    updateDeviceConfig: mockedRequester(undefined, 'plots.update'),
    getSoilMesh: mockedRequester(mockedSoilMeshResponse, 'plots.getSoilMesh')
};
export default mock;
